import React from 'react';
import ContentLayout from '../ContentLayout';
import CategoryContent from './CategoryContent';


function ManageCategories() {

    return (
        <ContentLayout>
            <CategoryContent/>
        </ContentLayout>
    );

}

export default ManageCategories;
